/**
 * Which UI generation to render: "legacy" (pre-refresh) or "refresh".
 *
 * The source of truth is the FI's `enable_sending_ui_refresh` branding flag.
 * It arrives asynchronously, so the last value seen for this browser is cached
 * in localStorage and applied before first paint to avoid a flash of the other
 * generation; the branding response then corrects it if the flag changed.
 */
export const UI_KEY = "np_sending_ui";

export const applyUi = (refresh) => {
  const ui = refresh ? "refresh" : "legacy";
  document.documentElement.dataset.ui = ui;
  try {
    window.localStorage.setItem(UI_KEY, ui);
  } catch (e) {
    // storage unavailable — the attribute is still set for this page load
  }
};

export const applyCachedUi = () => {
  let ui = "legacy";
  try {
    ui = window.localStorage.getItem(UI_KEY) === "refresh" ? "refresh" : "legacy";
  } catch (e) {
    // fall through to legacy
  }
  document.documentElement.dataset.ui = ui;
};
